/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getIntraOPCharts } from 'app/entities/intra-op-chart/intra-op-chart.reducer';
import { getEntities as getPostOPRecoveryRecords } from 'app/entities/post-op-recovery-record/post-op-recovery-record.reducer';
import { getEntities as getPreOpAnaesthesiaCharts } from 'app/entities/pre-op-anaesthesia-chart/pre-op-anaesthesia-chart.reducer';
import { OpMedicationType } from 'app/shared/model/enumerations/op-medication-type.model';
import { createEntity, getEntity, reset, updateEntity } from './op-medication.reducer';

export const OpMedicationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const medicines = useAppSelector(state => state.medicine.entities);
  const intraOPCharts = useAppSelector(state => state.intraOPChart.entities);
  const postOPRecoveryRecords = useAppSelector(state => state.postOPRecoveryRecord.entities);
  const preOpAnaesthesiaCharts = useAppSelector(state => state.preOpAnaesthesiaChart.entities);
  const opMedicationEntity = useAppSelector(state => state.opMedication.entity);
  const loading = useAppSelector(state => state.opMedication.loading);
  const updating = useAppSelector(state => state.opMedication.updating);
  const updateSuccess = useAppSelector(state => state.opMedication.updateSuccess);
  const opMedicationTypeValues = Object.keys(OpMedicationType);

  const handleClose = () => {
    navigate(`/op-medication${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getMedicines({}));
    dispatch(getIntraOPCharts({}));
    dispatch(getPostOPRecoveryRecords({}));
    dispatch(getPreOpAnaesthesiaCharts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timeAdvised !== undefined && typeof values.timeAdvised !== 'number') {
      values.timeAdvised = Number(values.timeAdvised);
    }
    if (values.timeAdministered !== undefined && typeof values.timeAdministered !== 'number') {
      values.timeAdministered = Number(values.timeAdministered);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...opMedicationEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      drug: medicines.find(it => it.id.toString() === values.drug?.toString()),
      intraOPChart: intraOPCharts.find(it => it.id.toString() === values.intraOPChart?.toString()),
      postOPRecoveryRecord: postOPRecoveryRecords.find(it => it.id.toString() === values.postOPRecoveryRecord?.toString()),
      preOpAnaesthesiaChart: preOpAnaesthesiaCharts.find(it => it.id.toString() === values.preOpAnaesthesiaChart?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'PREOP',
          ...opMedicationEntity,
          surgery: opMedicationEntity?.surgery?.id,
          drug: opMedicationEntity?.drug?.id,
          intraOPChart: opMedicationEntity?.intraOPChart?.id,
          postOPRecoveryRecord: opMedicationEntity?.postOPRecoveryRecord?.id,
          preOpAnaesthesiaChart: opMedicationEntity?.preOpAnaesthesiaChart?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.opMedication.home.createOrEditLabel" data-cy="OpMedicationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.opMedication.home.createOrEditLabel">Create or edit a OpMedication</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="op-medication-id"
                  label={translate('tinyMedicRestApp.opMedication.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.type')}
                id="op-medication-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {opMedicationTypeValues.map(opMedicationType => (
                  <option value={opMedicationType} key={opMedicationType}>
                    {translate(`tinyMedicRestApp.OpMedicationType.${opMedicationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.timeAdvised')}
                id="op-medication-timeAdvised"
                name="timeAdvised"
                data-cy="timeAdvised"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.timeAdministered')}
                id="op-medication-timeAdministered"
                name="timeAdministered"
                data-cy="timeAdministered"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.dose')}
                id="op-medication-dose"
                name="dose"
                data-cy="dose"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.notes')}
                id="op-medication-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.active')}
                id="op-medication-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.cursor')}
                id="op-medication-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.lastupdated')}
                id="op-medication-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.microSec')}
                id="op-medication-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opMedication.timestampentry')}
                id="op-medication-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="op-medication-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.opMedication.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-medication-drug"
                name="drug"
                data-cy="drug"
                label={translate('tinyMedicRestApp.opMedication.drug')}
                type="select"
                required
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-medication-intraOPChart"
                name="intraOPChart"
                data-cy="intraOPChart"
                label={translate('tinyMedicRestApp.opMedication.intraOPChart')}
                type="select"
                required
              >
                <option value="" key="0" />
                {intraOPCharts
                  ? intraOPCharts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-medication-postOPRecoveryRecord"
                name="postOPRecoveryRecord"
                data-cy="postOPRecoveryRecord"
                label={translate('tinyMedicRestApp.opMedication.postOPRecoveryRecord')}
                type="select"
                required
              >
                <option value="" key="0" />
                {postOPRecoveryRecords
                  ? postOPRecoveryRecords.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-medication-preOpAnaesthesiaChart"
                name="preOpAnaesthesiaChart"
                data-cy="preOpAnaesthesiaChart"
                label={translate('tinyMedicRestApp.opMedication.preOpAnaesthesiaChart')}
                type="select"
              >
                <option value="" key="0" />
                {preOpAnaesthesiaCharts
                  ? preOpAnaesthesiaCharts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/op-medication" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OpMedicationUpdate;
